import { render, staticRenderFns } from "./ReportsListModal.vue?vue&type=template&id=38c5c226&scoped=true"
import script from "./ReportsListModal.vue?vue&type=script&lang=js"
export * from "./ReportsListModal.vue?vue&type=script&lang=js"
import style0 from "./ReportsListModal.vue?vue&type=style&index=0&id=38c5c226&prod&scoped=true&lang=css"
import style1 from "./ReportsListModal.vue?vue&type=style&index=1&id=38c5c226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5c226",
  null
  
)

export default component.exports